import { InjectionToken, type Type } from '@angular/core';
import { type ToolType } from '@bizzdesign/bizzdesign-sdk';
import { type ToolContainer } from '@bizzdesign/shared/models';
import { type ToolInputsFactory } from '@bizzdesign/shared/models';

export type ToolSpecRegister = Record<
  ToolType,
  {
    containerType: () => Promise<Type<ToolContainer<any>>>;
    inputsFactoryType: () => Promise<Type<ToolInputsFactory>>;
  }
>;

export const TOOL_SPEC_REGISTER = new InjectionToken<ToolSpecRegister>(
  'toolSpecRegister',
);
